<template>
  <div>
    <el-dialog
      title="修改头像"
      :visible.sync="showDialog"
      width="30%">
      <el-radio-group v-model="radio1" size="mini">
        <el-radio-button label="1"> 自定义头像</el-radio-button>
        <el-radio-button label="2"> 默认头像</el-radio-button>
      </el-radio-group>
      <template v-if="radio1 === '1'">
        <p class="text-size">图片格式必须为：png,jpeg,jpg；不可大于2M；建议使用png格式图片，以保持最佳效果；建议图片尺寸为144px*144px</p>
        <el-button @click="openCropper" size="mini" class="mb-3">
          上传图片
        </el-button>
        <!--预览框-->
        <div class="preview-box">
          <div class="cropper-container">
            <vue-cropper
              ref="cropper"
              :img="option.img"
              :outputSize="option.size"
              :outputType="option.outputType"
              :aspectRatio="1"
              :autoCrop="true"
              :autoCropWidth="200"
              :autoCropHeight="200"
              :fixedBox="true"
              :info="false"
              :canScale="true"
              :canMove="true"
              :canMoveBox="false"
              @realTime="onCropChange"
            ></vue-cropper>
          </div>
          <div class="vatar-Preview">
            <p>预览头像</p>
            <div class="avatar-img">
            <img  :src="avatar"  v-if="avatar"  />
            </div>
          </div>
        </div>
      </template>
      <template v-else>
        <ul class="avatar-list">
          <li v-for="n in 12" :key="n" @click="selectAvatar(n)" :class="{'active': defaultAvatar === n}">
            <img :src="`/images/avatar/avatar_${n}.png`" alt="">
            <i v-if="defaultAvatar === n" class="el-icon-success"></i>
          </li>
        </ul>
      </template>
      <span slot="footer" class="dialog-footer">
        <!-- <p class="remind">* 请上传或选择要替换的头像图片</p> -->
        <el-button @click="showDialog = false">取 消</el-button>
        <el-button type="primary" :loading="loading" @click="confirmCrop">确 定</el-button>
      </span>
    </el-dialog>
    <input ref="fileInput" type="file" accept="image/*" style="display:none" @change="onFileChange" />
  </div>
</template>

<script>
import {  mapActions} from 'vuex'
import { VueCropper } from 'vue-cropper'
 import { UploadImages } from '@/assets/utils/uploadFiles'
export default {
  components: { VueCropper },
  data() {
    return {
      showDialog: false,
      loading: false,
      avatar: '',
      defaultAvatar:'',
      radio1: '1',
      option: {
        img: '',
        size: 0.9, // 图片质量 0~1
        outputType: 'png' // 输出格式 png / jpeg
      }
    }
  },
  methods: {
    ...mapActions(['POST_SetAvatar']),
    //开启或关闭上传头像
    showDialogChange() {
      this.showDialog = !this.showDialog
    },
    openCropper() {
      this.$refs.fileInput.click()
    },
    onFileChange(e) {
      const file = e.target.files[0]
      if (!file) return
      const reader = new FileReader()
      reader.readAsDataURL(file)
      reader.onload = (res) => {
        this.option.img = res.target.result
        this.showDialog = true
      }
      e.target.value = ''
    },
    //自定义头像
    onCropChange() {
      // 直接拿到 base64
      this.$refs.cropper.getCropData((base64) => {
        this.avatar = base64 // 页面预览直接赋值base64
        // 传给后端
        // this.$axios.post('/pc/upload/avatar', { avatar: base64 }).then(res => {
        //   if (res.code === '00000') {
        //     this.showDialog = false
        //   }
        // })
      })
    },
    //默认头像
    selectAvatar(n){
      this.defaultAvatar = n
    },
    //确认修改头像
    async confirmCrop(){
      let url='';
      if(this.radio1 === '1'){
        if(!this.avatar){
          this.$message.error('请上传头像')
          return
        }
        url = this.avatar
      }else{
        if(!this.defaultAvatar){
          this.$message.error('请选择默认头像')
          return
        }
        //图片转换为base64格式
        const res = await this.urlToBase64(`/images/avatar/avatar_${this.defaultAvatar}.png`)
        url = res
      }
        this.showDialog = false;
        //上传图片
        let pic = await UploadImages([url]);
        let avatar = pic.join(',');
        //设置头像
        await this.POST_SetAvatar({
          data:{avatar:avatar},
          successFun:()=>{
            this.$message.success('头像修改成功');
          }
        })
    },

    urlToBase64(url) {
      return new Promise((resolve, reject) => {
        const img = new Image()
        img.crossOrigin = 'Anonymous'
        img.src = url
        img.onload = function () {
          const canvas = document.createElement('canvas')
          canvas.width = img.width
          canvas.height = img.height
          const ctx = canvas.getContext('2d')
          ctx.drawImage(img, 0, 0)
          const base64 = canvas.toDataURL('image/png')
          resolve(base64)
        }
        img.onerror = (err) => {
          reject(`图片加载失败：${url}`)
        }
      })
    }
  }
}
</script>

<style scoped>
.avatar-box {
  width: 120px;
  height: 120px;
  border-radius: 50%;
  overflow: hidden;
  border:1px solid #ccc;
  cursor: pointer;
}
.avatar-default{
  display:flex;align-items:center;justify-content:center;height:100%;
  color:#999;font-size:14px;
}
.cropper-container{
  height:300px;
  width:45%;
  border-radius: 4px;
  overflow: hidden;
}
.text-size{
  font-size: 12px;
  padding: 10px 0;
}
.preview-box{
  display: flex;
  justify-content: space-between;
}
.vatar-Preview{
  background-color: #f6f8f9;
  padding: 16px;
  height: 270px;
  width: 45%;
  border-radius: 4px;
  overflow: hidden;
  
}
.avatar-img{
 width: 180px;
  height: 180px;
  display: block;
  margin: 0 auto;
  border-radius: 50%;
  margin-top: 30px;
  background-color: #fff;
  overflow: hidden;
}
.avatar-img img{
    width: 100%;
    height: 100%;
}
.remind{
  float: left;
  line-height: 30px;
  color: red;
}
.avatar-list{
  display: flex;
  flex-wrap: wrap;
  margin-top: 20px;
}
.avatar-list li{
  width: 15%;
  background-color: #f6f8f9;
  margin-right: 2%;
  margin-bottom: 2%;
  border-radius: 4px;
  cursor: pointer;
  overflow: hidden;
  position: relative;
}
.avatar-list li i{
  position: absolute;
  top: 5px;
  right: 5px;
  font-size: 18px;
  color: #fff;
}

.avatar-list li:nth-child(6n){
  margin-right: 0;
}
.avatar-list li img{
  width: 70%;
  margin: 10px auto;
  display: block;
}
.avatar-list .active{
  background-color: var(--smtc-color-primary);
}
</style>